
import { Component } from "vue-property-decorator";
import { mapActions } from "vuex";
import baseUserContextEmptyPage from "./baseUserContextEmptyPage";

@Component({
  methods: { ...mapActions(["loginUser"]) }
})
export default class loginPage extends baseUserContextEmptyPage {

  onLoggedIn() {
    var instance = this;
    instance.$router.push({ name: "home" });
  }
}
